<template>
    <div class="selected-option">
        <span>{{ selectedData.name }}</span>
        <ImageLoader :src="selectedData.icon" :name="selectedData.name" v-if="selectedData.icon != ''"></ImageLoader>
    </div>
</template>

<script>
    import ImageLoader from "./ImageLoader";

    export default {
        name: "OptionHeader",
        components: {
            ImageLoader
        },
        props: {
            'selectedData': {
                type: Object,
                required: true
            }
        }
    }
</script>